<template>
  <div class="about">
    <div id="cContent">
      <div id="elInput">
        <el-input
          placeholder="请输入项目名称查询"
          v-model="filterText"
          class="input-with-select"
          size="small"
          clearable>
          <el-button slot="append" icon="el-icon-search" @click="treeFilter"></el-button>
        </el-input>
      </div>
      <el-tree
        class="filter-tree"
        :data="enumData"
        :props="defaultProps"
        node-key="id"
        highlight-current
        :expand-on-click-node="false"
        @node-click="treeNodeClick"
        :filter-node-method="filterNode"
        :default-expanded-keys="defaultExpandedKeys"
        ref="tree">
      </el-tree>
    </div>
  </div>
</template>

<script>
  import {getProOrgTree} from '../api/proOrg'
  import main from "../views/defaultImg";
  export default {
    data () {
      return {
        filterText: '',
        enumData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        parentId: '',
        nodeId: '',
        formLabelWidth: '120px',
        chooseTreeNode: {},
        defaultExpandedKeys: []
      }
    },
    props: {
      parentMsg: Object
    },
    watch: {
      parentMsg (newVal, oldVal) {
        this.getTemplateTree('refresh')
      }
    },
    mounted: function () {
      this.getTemplateTree('new')
    },
    methods: {
      treeFilter () {
        this.$refs.tree.filter(this.filterText)
      },
      getTemplateTree (data) {
        getProOrgTree(this.$qs.stringify({async:0,userId:0})).then(response => {
          let mainTree = {id:'-1', label:'项目组织'}
          if (response.length <= 0) {
            this.enumData = [mainTree]
            this.$emit('treeInfo', { 'listenParentId': '-1', 'listenParentName': '暂无' })
          } else {
            mainTree.children = response
            let temp = [mainTree]

            // 展开至第一级
              this.defaultExpandedKeys = [temp[0].id]
              if (temp[0].children !== null && temp[0].children.length > 0) {
                // 展开至第二级
                for (var i = 0; i < temp[0].children.length; i++) {
                  this.defaultExpandedKeys.push(temp[0].children[i].id)
                }
            }
            this.enumData = temp
            if (data !== 'refresh') {
              this.$emit('treeInfo', { 'listenParentId': temp[0].id, 'listenParentName': temp[0].label })
            }
          }
        }).catch(error => {
          console.log('error:' + error.toString())
        })
      },
      treeNodeClick (node) {
        this.chooseTreeNode = node
        this.$emit('treeInfo', { 'listenParentId': node.id, 'listenParentName': node.label })
      },
      filterNode (value, data) {
        if (!value) return true
        return data.label.indexOf(value) !== -1
      }
    }
  }
</script>

<style lang="less">
  .about {
    padding: 10px 0;
    height: 100%;
    box-sizing: border-box;
  }

  #topBar {
    margin-top: 5px;
  }

  #name {
    float: left;
    color: black;
    font-size: 18px;
    font-weight: bold;
    margin-left: 15px;
  }

  #cContent{
    height: 100%;
    padding: 0px;
    margin: 0px;
    .el-tree{
      height: calc(100% - 42px);
      overflow-y: auto;
    }
  }
  #elInput{
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProOrgTree.vue